import { required, email } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
import PropertyContact from "@/services/Property/PropertyContact";

export const form = () => cloneDeep({
  propertyContactId: {
    label: 'Select contact from list',
    type: 'select',
    value: '',
    options: [],
    optionsFn: async () => {
      const { data } = await PropertyContact.list();
      return data.data;
    },
    trackBy: 'propertyContactId',
    labelBy: 'name',
    hideReadOnly: true,
  },
  firstName: {
    label: 'First name',
    type: 'text',
    value: '',
  },
  lastName: {
    label: 'Last name',
    type: 'text',
    value: '',
  },
  primaryContactNumber: {
    label: 'Primary contact number',
    type: 'text',
    value: '',
  },
  secondaryContactNumber: {
    label: 'Secondary contact number',
    type: 'text',
    value: '',
  },
  jobRole: {
    label: 'Job role',
    type: 'text',
    value: '',
  },
  email: {
    label: 'Email',
    type: 'text',
    value: '',
  },
  notes: {
    label: 'Notes',
    type: 'textarea',
    value: '',
  },
});

export const validators = {
  firstName: {
    required,
  },
  lastName: {
    required,
  },
  primaryContactNumber: {
    required,
  },
  email: {
    email,
  },
};
